import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

// import lib
import { dateTimeFormat } from '../../lib/dateTimeHelper';

//import modal
import ProfileModal from "./ProfileModal"

const AccountSettings = () => {


  const { t, i18n } = useTranslation()

  // redux-state
  const { firstName, lastName, loginHistory, profile } = useSelector((state) => state.account);


  //state
  const [Modal, setModal] = useState(false)


  //function
  const handleCloseModal = () => {
    setModal(false)
  }

  return (
    <div className=" ">
      <ProfileModal isShow={Modal} onHide={handleCloseModal} />
      <div className="row">
        <div className="col-lg-12">
          <div className="rounded-[4px] p-4 border border-[#6B7280]/25 mb-6">
            <div className="flex items-center gap-4">
              <img
                alt="arrow"
                className="w-[60px] h-[60px] rounded-full object-cover"
                src={profile ? profile : require("../../assets/images/copy_usericon.png")}
              />
              <div className="flex flex-col gap-1">
                <h3 className="text-xl font-semibold text-[#395645] m-0">{firstName}{" "}{lastName}</h3>
                <h5 className="text-sm text-gray-500 m-0">
                  {(loginHistory && loginHistory.createdAt) && <span>{t("LAST_LOGIN")}{" "}: {" "}{dateTimeFormat(loginHistory.createdAt)}</span>}
                </h5>
                <h6 className="flex items-center gap-2 text-sm font-medium text-[#395645] m-0 mt-1">
                  <span
                    className="cursor-pointer hover:underline"
                    onClick={() => setModal(true)}
                  >
                    {t("EDIT_PROFILE")}
                  </span>
                  <span className="text-gray-300">|</span>
                  <span
                    className="cursor-pointer hover:underline"
                    data-bs-toggle="modal"
                    data-bs-target="#changepassword_modal"
                  >
                    {t("CHANGE_PASSWORD")}
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountSettings;